'use client';

import { HeaderLogo } from './HeaderLogo';
import {
  Container,
  FindAnFAButton,
  Header,
  HeaderButtons,
  HeaderButtonsDesktop,
  HeaderNav,
  LoginButton,
  LoginButtonContainer,
  NavigationContainer,
  ResponsiveContainer,
} from './HeaderRedesign.style';
import { FinancialAdviceSubMenu } from './menu/header-desktop-menu/financial-advice-sub-menu/FinancialAdviceSubMenu';
import { ProductNavigationSubMenu } from './menu/header-desktop-menu/product-navigation-sub-menu/ProductNavigationSubMenu';
import { ResourcesNavigationSubMenu } from './menu/header-desktop-menu/resources-sub-menu/ResourcesNavigationSubMenu';
import { HeaderMobileMenu } from './menu/header-mobile-menu/HeaderMobileMenu';
import { NavLink } from './navigation/NavLink';
import { Popover } from './navigation/Popover';
import { useState } from 'react';
import { useEffectOnce } from 'react-use';

export const HeaderRedesign = () => {
  const [loaded, setLoaded] = useState(false);
  useEffectOnce(() => setLoaded(true));

  return (
    <Container as="header" data-isloaded={loaded}>
      <ResponsiveContainer>
        <Header>
          <LoginButtonContainer>
            <LoginButton size="small" />
          </LoginButtonContainer>
          <HeaderLogo />
          <NavigationContainer>
            <HeaderNav>
              <Popover text="Financial Advice">
                <FinancialAdviceSubMenu />
              </Popover>
              <Popover text="Products">
                <ProductNavigationSubMenu />
              </Popover>
              <Popover text="Why Thrivent">
                <div>content here</div>
              </Popover>
              <NavLink
                href="/working-with-a-financial-advisor"
                text="Working With Us"
              />
              <NavLink href="/giving-back" text="Generosity" />
              <Popover text="Resources">
                <ResourcesNavigationSubMenu />
              </Popover>
            </HeaderNav>

            <HeaderButtons>
              <HeaderMobileMenu></HeaderMobileMenu>
            </HeaderButtons>

            <HeaderButtonsDesktop>
              <LoginButton size="small" />
              <div>
                <FindAnFAButton
                  size="small"
                  variant="secondary"
                  //href="https://local.thrivent.com"
                >
                  Find financial advisors
                </FindAnFAButton>
              </div>
            </HeaderButtonsDesktop>
          </NavigationContainer>
        </Header>
      </ResponsiveContainer>
    </Container>
  );
};
